import { CardTemplate, InputField } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useCheckoutLabels } from "../hooks/useCheckoutLabels";
import { formatContactName } from "../utils/formatContactName";

interface ContactDetailsCardProps {
    isLoading?: boolean;
}

export const ContactDetailsCard = ({
    isLoading = false,
}: ContactDetailsCardProps): JSX.Element => {
    const labels = useCheckoutLabels();
    const { data: userData } = useGetUserInfoQuery();

    const contactName = userData
        ? formatContactName(
              userData.firstName,
              userData.insertion,
              userData.lastName,
          )
        : "";

    return (
        <CardTemplate title={labels.contactDetailsTitle} isLoading={isLoading}>
            <InputField
                id="checkout-company"
                label={labels.companyName}
                value={userData?.dealer?.name ?? ""}
                disabled
                fieldVariant="filled"
                required
                isLoading={isLoading}
            />
            <div className="p-checkout-page__field-row">
                <InputField
                    id="checkout-email"
                    label={labels.email}
                    value={userData?.email ?? ""}
                    type="email"
                    disabled
                    fieldVariant="filled"
                    required
                    isLoading={isLoading}
                />
                <InputField
                    id="checkout-contact"
                    label={labels.contactName}
                    value={contactName}
                    disabled
                    fieldVariant="filled"
                    required
                    isLoading={isLoading}
                />
            </div>
            <InputField
                id="checkout-phone"
                label={labels.phone}
                value={userData?.phoneNumber ?? ""}
                type="tel"
                placeholder={labels.phonePlaceholder}
                disabled
                fieldVariant="filled"
                isLoading={isLoading}
            />
        </CardTemplate>
    );
};
